
export const COLUMNS = [
    {
        Header: 'Naziv',
        accessor: 'name'

    },
    {
        Header: 'Kalorije',
        accessor: 'calories'

    },
    {
        Header: 'Proteini',
        accessor: 'proteins'

    },
    {
        Header: 'Ugljeni hidrati',
        accessor: 'carbohydrates'

    },
    {
        Header: 'Masti',
        accessor: 'fats'

    },

]